import makeStyles from '@mui/styles/makeStyles';

export default makeStyles((theme) => ({
    centerDivContent: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 'inherit'
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        marginLeft: 14,
        marginRight: 14
    },
    svg: {
        width: '100%',
        maxWidth: 24,
        maxHeight: 24
    },
    paper: {
        position: 'relative',
        maxWidth: 634,
        width: '96%',
        padding: '10px',
        backgroundColor: '#fff',
        '&:focus': {
            outline: 'none'
        },

        overflowY: 'scroll',
        height: 'auto',
        maxHeight: '100vh',
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            overflow: 'visible'
        }
    },
    heading: {
        fontWeight: 600,
        letterSpacing: '.04em',
        lineHeight: 2
    },
    divider: {
        margin: '10px 0 20px 0'
    },
    close: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginLeft: 'auto'
    },
    modalShadow: {
        boxShadow: '2px 2px 8px 1px rgba(0, 0, 0, 0.04)'
    }
}));
